import React, { useState } from "react";
import {Outlet, Link } from "react-router-dom";
import './Aktuelles.css';
import TireIcon from '../components/TireIcon';
import Footer from "../components/Footer";

const newsItems = [
    {
        title: 'Gerädert vom Winter? Zeit für einen Wechsel!', 
        date: '21.02.2025',
        content: 'Jetzt Termin zum Räderwechsel sichern und sicher in den Frühling starten!'
      },
      {
        title: 'Mit uns in die Urlaubszeit!',
        date: '26.04.2024',
        content: 'Urlaubscheck für Ihr Fahrzeug, damit die Reise sorgenfrei startet.'
      },
      {
        title: 'WIR STEHEN IHNEN MIT RAD UND TAT ZUR SEITE!',
        date: '08.03.2024',
        content: 'Unser Team ist für Sie persönlich da, zuverlässig und kompetent.'
      },
      {
        title: 'GLATT VERGESSEN? Wir erinnern Sie an den Räderwechsel!',
        date: '22.08.2023',
        content: 'Nutzen Sie unseren Erinnerungsservice für saisonale Fahrzeugchecks.'
      },
      {
        title: 'Wir sind für Sie da.',
        date: '12.01.2022',
        content: 'Auch in herausfordernden Zeiten, Ihr Auto ist bei uns in besten Händen.'
      }
  ];

const Aktuelles = () => {

    const [openIndex, setOpenIndex] = useState(null);

    const toggleItem = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const [isOpen, setIsOpen] = useState(false);
        
          const toggleMobileMenu = () => {
            setIsOpen(!isOpen);
          };

    return(
        <section className="container-aktuelles"
            style={{ overflow: 'hidden'}}
        >
            <section>
                <div className="navbar-aktuelles"
                style={{
                minHeight: '100vh',
                width: '100%',
                backgroundImage: 'url(/assets/aktuelles-hero.png)',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                zIndex: 0,
            }}>
                    {/* Burger Button (mobile only) */}
                    <div className="burger-button" onClick={toggleMobileMenu}>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                    </div>
        
                    {/* Mobile Menu */}
                    <nav className={`mobile-menu ${isOpen ? "open" : ""}`}>
                        <Link to="/überUns" onClick={toggleMobileMenu}>Über Uns</Link>
                        <Link to="/leistungen" onClick={toggleMobileMenu}>Leistungen</Link>
                        <Link to="/" onClick={toggleMobileMenu}>Home</Link>
                        <Link to="/kontakt" onClick={toggleMobileMenu}>Kontakt</Link>
                        <Link to="/impressum" onClick={toggleMobileMenu}>Impressum</Link>
                        <Link to="/datenschutz" onClick={toggleMobileMenu}>Datenschutz</Link>
                        <Link to="/blog" onClick={toggleMobileMenu}>Blog</Link>
                    </nav>
        
                    {/* Hexagon Nav (desktop) */}
                    <section className="hero--inner">
                        <div className="hexagon-wrapper" id="hexagon-über-uns"><div className="hexagon"><i><Link to="/überUns" className="link">Über Uns</Link></i></div></div>
                        <div className="hexagon-wrapper" id="hexagon-leistungen"><div className="hexagon"><i><Link to="/leistungen" className="link">Leistungen</Link></i></div></div>
                        <div className="hexagon-wrapper" id="hexagon-aktuelles"><div className="hexagon"><i><Link to="/" className="link">Home</Link></i></div></div>
                        <div className="hexagon-wrapper" id="hexagon-kontakt"><div className="hexagon"><i><Link to="/kontakt" className="link">Kontakt</Link></i></div></div>
                        <div className="hexagon-wrapper" id="hexagon-impressum"><div className="hexagon"><i><Link to="/impressum" className="link">Impressum</Link></i></div></div>
                        <div className="hexagon-wrapper" id="hexagon-datenschutz"><div className="hexagon"><i><Link to="/datenschutz" className="link">Datenschutz</Link></i></div></div>
                        <div className="hexagon-wrapper" id="hexagon-blog"><div className="hexagon"><i><Link to="/blog" className="link">Blog</Link></i></div></div>
                    </section>
                </div>

                <Outlet />

                <div className="news-container"
                style={{
                minHeight: '100vh',
                width: '100%',
                backgroundImage: 'url(/assets/aktuelles-body.png)',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                zIndex: 0,
            }}>
                    {newsItems.map((item, index) => (
                        <div key={index} className="news-wrapper">
                            <div className="news-item" onClick={() => toggleItem(index)}>
                                <div className="text-block">
                                    <h3 className="news-title">{item.title}</h3>
                                    {/*<p className="news-date">{item.date}</p>*/}
                                </div>
                                <div className="icon"><TireIcon rotated={openIndex === index} /></div>
                            </div>
                            {openIndex === index && (
                                <div className="news-content">
                                    <p>{item.content}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
                
                
            </section>
            <div className="footer-homepage">
                < Footer />
            </div>
        </section>
    );
};

export default Aktuelles;

/**
 * <div class="hexagon-wrapper">
                <div class="hexagon" id="hexagon-über-uns">
                    <i class="fab-Über-Uns"><Link to="/überUns" class="link">Über Uns</Link></i>
                </div>
                </div>
                <div class="hexagon-wrapper" id="hexagon-leistungen">
                    <div class="hexagon" >
                        <i class="fab-Leistungen"><Link to="/leistungen" class="link">Leistungen</Link></i>
                    </div>
                </div>
                <div class="hexagon-wrapper" id="hexagon-aktuelles">
                    <div class="hexagon">
                        <i class="fab-Aktuelles"><Link to="/kontakt" class="link">Kontakt</Link></i>
                    </div>
                </div>
                <div class="hexagon-wrapper" id="hexagon-kontakt">
                    <div class="hexagon">
                        <i class="fab-Kontakt"><Link to="/" class="link">Home</Link></i>
                    </div>
                </div>
                <div class="hexagon-wrapper" id="hexagon-impressum">
                    <div class="hexagon">
                        <i class="fab-Impressum"><Link to="/impressum" class="link">Impressum</Link></i>
                    </div>
                </div>
                <div class="hexagon-wrapper" id="hexagon-datenschutz">
                    <div class="hexagon">
                        <i class="fab-datenschutz"><Link to="/datenschutz" class="link">Datenschutz</Link></i>
                    </div>
                </div>
                <div class="hexagon-wrapper" id="hexagon-blog">
                    <div class="hexagon">
                        <i class="fab-blog"><Link to="/blog" class="link">Blog</Link></i>
                    </div>
                </div>
 */